import styled from 'styled-components';

import { Container } from '../components/MainStyledComponents';

export const ContainerStyled = styled(Container)`
  position: relative;
  flex-direction: column;
  align-items: flex-start;
  border-radius: ${({ theme }) => theme.spaces.s}rem;
`;

export const ContainerTag = styled.div`
  position: absolute;
  top: 4.6rem;
  left: 72.9rem;
  @media (max-width: ${({ theme }) => theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    top: 0.6rem;
    left: 66.5rem;
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet *
    theme.percentBaseResponsive}rem) {
    top: 0.5rem;
    left: 80.8rem;
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    top: 6.5rem;
    left: 44.9rem;
  }
`;
